module.exports = __WEBPACK_EXTERNAL_MODULE_828__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 828
// module chunks = 9